export interface RetryableResult {
  success: boolean;
  error?: { code: string; message: string } | null;
}

export async function withRetry<T extends RetryableResult>(
  fn: () => Promise<T>,
  maxRetries = 3,
): Promise<T> {
  const NON_RETRYABLE = ["CART_INVALID"];

  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    const result = await fn();

    if (result.success) return result;

    const retryable =
      !NON_RETRYABLE.includes(result.error?.code ?? "") && attempt < maxRetries;

    if (!retryable) return result;

    await new Promise((r) => setTimeout(r, 1000 * Math.pow(2, attempt)));
  }

  // Should never reach here, but satisfy TS
  return await fn();
}
